import { Country } from '@superbet-group/web.types';
import {
    MarketAllowance,
    OutcomeAllowance,
} from '../types';

export function shouldOmitInTarget(
    combinationKey: string,
    target: Country,
    allowedMarketCombinations?: Record<string, Set<MarketAllowance>>,
    allowedOutcomeCombinations?: Record<string, Set<OutcomeAllowance>>,
) {
    if (allowedMarketCombinations && combinationKey in allowedMarketCombinations) {
        const marketAllowances = allowedMarketCombinations[combinationKey];
        if (Array.from(marketAllowances).some((allowance) => allowance.omitInTargets?.includes(target))) {
            return true;
        }
    }

    if (allowedOutcomeCombinations && combinationKey in allowedOutcomeCombinations) {
        const outcomeAllowances = allowedOutcomeCombinations[combinationKey];
        if (Array.from(outcomeAllowances).some((allowance) => allowance.omitInTargets?.includes(target))) {
            return true;
        }
    }

    return false;
}
